import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { VideoContent } from 'widgets/RecordVideo/ui/video/VideoContent'
import { RecordActions } from 'widgets/Record'
import { type RecordVideoStore } from 'widgets/RecordVideo/store/recordVideoStore'
import styles from './styles.module.scss'

type IRecordVideoContentProps = {
  store: RecordVideoStore
}

export const RecordVideoContent: FC<IRecordVideoContentProps> = observer(({ store }) => {
  return (
    <div className={styles.wrap}>
      <VideoContent recordStore={store.recordStore} />
      <RecordActions recordStore={store.recordStore} />
    </div>
  )
})
